// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ace21015","732":"8ceb6dac","977":"9888ee86"}[chunkId] + ".chunk.js";
};